import { YANDEX_METRIKA_ID } from '../const';

const SOURCE = "Studio" as const;
type SOURCE = typeof SOURCE;

type TrackEventParams = {
    eventAction: string;
    eventCategory?: string;
    eventLabel?: string;
    userSessionTime?: string;
    promptText?: string;
    userReturnsData?: string;
    selectedAvatarId?: string;
    selectedVoice?: string;
    selectedBackgroundId?: string;
    isUserChangePrompt?: string;
    sourceClickGetLink?: SOURCE;
    sourceClickContactUs?: SOURCE;
    avatarType?: "2d" | "3d";
};

declare global {
    interface Window {
      ym?: (...args: any[]) => void;
    }
}

const trackEvent = (eventType: string, params: TrackEventParams): void => {
    const eventData = { eventType, ...params };

    if (window.ym) {
        window.ym(YANDEX_METRIKA_ID, 'reachGoal', params.eventAction, eventData);
        console.log('reachGoal', params.eventAction, eventData);
    }
};

export const trackPublish = (): void => {
    trackEvent("click", { eventAction: "publish_avatar_button_click", eventCategory: "Links", eventLabel: "Publish Avatar Button" });
};

export const trackUserTimeInApp = (time: string): void => {
    trackEvent("timing", {
        eventAction: "user_time_in_app",
        eventCategory: "User Engagement",
        userSessionTime: time,
    });
};

export const trackAvatarCreationFromPopup = (): void => {
    localStorage.removeItem("isUserFromPopup");
    trackEvent("click", {
        eventAction: "start_creation_from_popup",
        eventCategory: "Links",
    });
};

export const trackPrompt = (promptText: string): void => {
    trackEvent("view", { eventAction: "avatar_prompt", eventCategory: "User Input", promptText });
};

export const trackUserReturns = (userId: string, userFirstEnter: string, userCurrentEnter: string,): void => {
    trackEvent("view", { eventAction: "user_returns", eventCategory: "User Engagement", userReturnsData: `userId: ${ userId }, userFirstEnter: ${ userFirstEnter }, userCurrentEnter: ${ userCurrentEnter }` });
};

export const trackSelectedAvatar = (avatarId: string): void => {
    trackEvent("click", { eventAction: "selected_avatar_id", eventCategory: "Use Avatars", selectedAvatarId: avatarId });
};

export const trackSelectedVoice = (voice: string): void => {
    trackEvent("click", { eventAction: "selected_voice_id", eventCategory: "Use Avatars", selectedVoice: voice });
};

export const trackSelectedBackground = (backgroundId: string): void => {
    trackEvent("click", { eventAction: "selected_background_id", eventCategory: "Use Avatars", selectedBackgroundId: backgroundId });
};

export const trackUserChangePrompt = (value: string): void => {
    trackEvent("click", { eventAction: "user_change_prompt", eventCategory: "Use Avatars", isUserChangePrompt: value });
};

export const trackClickStartStream = (): void => {
    trackEvent("click", { eventAction: "click_start_stream_from_studio", eventCategory: "User Engagement" });
};

export const trackClickContactUs = (avatarType: "2d" | "3d"): void => {
    trackEvent("click", { eventAction: "click_contact_us", eventCategory: "User Engagement", sourceClickContactUs: "Studio", avatarType });
};

export const trackEnterToStudio = (): void => {
    trackEvent("click", { eventAction: "track_enter_studio", eventCategory: "User Engagement" });
};
